module.exports = __webpack_public_path__ + "static/media/footer_orange.df2e1a50.png";